import { Navigate, useParams } from "react-router-dom"

/** Old /recruitment/candidates/:candidateId links now open the candidate panel on the list page. */
export function CandidateDetailRedirect() {
  const { candidateId } = useParams<{ candidateId: string }>()

  return (
    <Navigate
      to={
        candidateId
          ? `/recruitment/candidates?candidateId=${encodeURIComponent(candidateId)}`
          : "/recruitment/candidates"
      }
      replace
    />
  )
}
